import { FirebaseProvider } from 'contexts/FirebaseContext';
import { UserProvider } from 'contexts/UserContext';

export function AppProvider({ children }: { children: React.ReactNode }) {
  return (
    <FirebaseProvider>
      <UserProvider>{children}</UserProvider>
    </FirebaseProvider>
  );
}
